var map = {
	"./australia.png": [
		21409,
		409
	],
	"./brazil.png": [
		89229,
		229
	],
	"./canada.png": [
		24693,
		693
	],
	"./france.png": [
		69250,
		250
	],
	"./global.png": [
		20278,
		278
	],
	"./iceland.png": [
		96101,
		101
	],
	"./japan.png": [
		35631,
		631
	],
	"./singapore.png": [
		8165,
		165
	],
	"./usa.png": [
		51166,
		166
	],
	"./world.png": [
		66743
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 68120;
module.exports = webpackAsyncContext;